<a
  class="category-bubble"
  appDisableClickEvent
  [routerLink]="['/c', category.slug]"
  [queryParams]="promotion ? { 'f.promotion': true } : ''"
  (click)="onCategoryClick(category)"
>
  <div
    class="category-bubble__bubble"
    [ngClass]="{
      'category-bubble__bubble__bubble-navigation': isInNavigationMenu,
      'category-bubble__bubble__bubble-default': !isInNavigationMenu
    }"
  >
    <figure>
      <img
        [ngClass]="{
          'navigation-scale': isInNavigationMenu,
          'default-scale': !isInNavigationMenu
        }"
        [appDefaultImage]="defaultCategoryImage"
        [alt]="category.slug"
        [appLazyLoadImage]="getSource('getCategoryImageSrc', category.id)"
        [srcSet]="getSource('getCategoryImageSrcSet', category.id)"
      />
    </figure>
  </div>
  <span
    [lang]="market"
    [ngClass]="{
      'category-title-in-navigation': isInNavigationMenu,
      'category-title-by-default': !isInNavigationMenu
    }"
    >{{ categoryName }}</span
  >
</a>
